import { TEAM_PENDING_INVITES_POLL_MS } from '@/lib/constants/team-polling';
import type { TeamInvite } from './api/team.api';

/**
 * React Query `refetchInterval` for the Team Access roster: poll while at
 * least one invite is still pending (it may be accepted at any moment), stop
 * once none is. Expired invites cannot change on their own, so they do not
 * keep the poll alive. Pure.
 *
 * @param invites The latest invites list, or `undefined` before it loads.
 * @returns The poll interval in ms, or `false` to stop polling.
 */
export function pendingInvitesPollInterval(invites: TeamInvite[] | undefined): number | false {
  return invites?.some((invite) => invite.status === 'pending') ? TEAM_PENDING_INVITES_POLL_MS : false;
}
